import React from 'react'

import { MenuItem, Box, MenuBulkAction } from 'front-end/src/components'
import { Trans } from '@lingui/macro'

interface ActivityHistoryTableBulkActionProps {
  selectedIds: number[]
  isLoading: boolean
  archiveEnrolments: (idsList: number[]) => Promise<void>
}

const CertificationDetailOverviewTableBulkAction = ({
  selectedIds,
  isLoading,
  archiveEnrolments
}: ActivityHistoryTableBulkActionProps) => {
  const isDisabled = !selectedIds.length || isLoading

  const handleClick = async () => {
    if (isLoading) return

    await archiveEnrolments(selectedIds)
  }

  return (
    <Box mr="12px">
      <MenuBulkAction isDisabled={isDisabled}>
        <MenuItem whiteSpace="nowrap" onClick={handleClick} maxW="none">
          <Trans>Archive enrolments</Trans>
        </MenuItem>
      </MenuBulkAction>
    </Box>
  )
}

export default CertificationDetailOverviewTableBulkAction
